import React, { useState, useRef } from "react";
import { useNavigate, Link} from "react-router-dom"
import { useAuth } from '../auth/AuthContext';
import toast from "react-hot-toast";


function HomePage() {




const [inputData, setInputData] = useState({
  email:"",
  password:""
})

const handleChange =(e)=>{
  const {name,value} = e.target;
  setInputData({
    ...inputData,
    [name]:value
  })
  
}


const  {login ,enterOtp,  verifyLoginOTP,loadingrequest} = useAuth();

const Navigate = useNavigate()


const handleLogin = async(e)=>{
  e.preventDefault();
  if(!inputData.email || !inputData.password){
    alert("Please fill all the fields");
    return;
  }

  try {

    await login(inputData);
     Navigate("/auth/v6/dash-board"); 
    sessionStorage.setItem("emailForOtp", inputData.email);
  } catch (error) { 
    console.log('error login fails' , error)
  }

  }





 const [otp, setOtp] = useState(new Array(6).fill(""));

  const inputRefs = useRef([]);

  const handleChangeotp= (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, ""); 

    if (!value && otp[index] === "") return; 

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1); 
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];

      if (!newOtp[index] && index > 0) {
        inputRefs.current[index - 1].focus();
      }

      newOtp[index] = "";
      setOtp(newOtp);
    }

    if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1].focus();
    }

    if (e.key === "ArrowRight" && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };


  // SUbmit OTP ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  //::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  const handleSubmitOTP =  async() => {
     const enteredOtp = otp.join(""); 
     const email = sessionStorage.getItem("emailForOtp");

    try {

          const credentials = {
            email: email, 
            otp: enteredOtp,
          };
          const result = await verifyLoginOTP(credentials);
            Navigate("/auth/v6/dash-board");       
    } catch (error) {
        console.error("OTP verification failed:", error);
      
    }
  };




//:::Resent OTP API ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

const apiUrl = process.env.REACT_APP_API_URL

const [resentLoading , setResentOtpLoading] = useState(false)


const resentOTP = async () => {

  setResentOtpLoading(true)
  const email = sessionStorage.getItem("emailForOtp");
  try {
    const response = await fetch(`${apiUrl}/auth/admin/resend-otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }), 
    });

    const result = await response.json();

    if (response.ok) {
      toast.success("OTP resent successfully:");
    } else {
      toast.error("Failed to resend OTP:");
    }
  } catch (error) {
    console.error("Server error:", error);
  }
    setResentOtpLoading(false)

};



  

  return (
    <div className="home-screen-bg">
      <div className="home-screen-main">
        <div className="home-screen-main-content">
          <div className="home-screen-main-cols">
                <p>Stay in Control of Customer Feedback Across All Your Services</p>
             
           
  <h6 class="home-screen-sb-heading-note">
    Do not refresh the page during login.
  </h6>
  


         
          </div>
          <div className="home-screen-login-content">

            <>

{
  enterOtp  === true ?
        <div className="enter-otp-container-login" style={{ textAlign: "center", marginTop: "50px" }}>
      <div>
        {otp.map((data, index) => (
          <input
            key={index}
            type="text"
            maxLength="1"
            value={data}
            onChange={(e) => handleChangeotp(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            ref={(el) => (inputRefs.current[index] = el)}
            className="inputStyle"
          />
        ))}
      </div>


      <button  className="buttonStyle" onClick={handleSubmitOTP}>
        Verify OTP
      </button>



{



  resentLoading ?

            <div className="regenrate-otp-login-home">Wait.. sending OTP Your Register email ID</div>

  :

          <div className="regenrate-otp-login-home" onClick={resentOTP}>Regenerate OTP</div>
}

    </div>
    :

    <> 

            <form onSubmit={handleLogin}>   

              <div className="inner-home-screen-login-content">

              <div  className="inner-home-screen-login-cont-row"><input placeholder="enter email id/ User ID"  name="email"  value={inputData.email} type="text" onChange={handleChange} ></input></div>
              <div  className="inner-home-screen-login-cont-row"><input placeholder="enter  password" type="password" name="password" value={inputData.password} onChange={handleChange} ></input></div>

{

  loadingrequest ?

        <div  className="inner-home-screen-login-cont-row"><div >Verifying...</div></div>

  :
        // <div  className="inner-home-screen-login-cont-row"><div >Verifying...</div></div>

    <div  className="inner-home-screen-login-cont-row"><button >Login</button></div>
}

            </div>
            </form>




            <div className="homepage-reset-password-btn">
              <Link to="/forgot-password">
             Reset Your Password ?
             </Link>
            </div>

</>

}


            </>




      
          </div>

        </div>
      </div>
    </div>
  );
}

export default HomePage;
